import React, { useState } from 'react';
import { StyledButtonContainer, StyledButton } from './Button.styled';

interface Props {
    padding: string | undefined
    textSize: string
    text: string
    image: string | null
    size: string
    event: ((e: HTMLButtonElement) => void) | undefined
}
const Button = (props: Props) => {

    return (
        <StyledButtonContainer>
            <StyledButton
                onClick={(e: React.MouseEvent<HTMLButtonElement>) => props.event && props.event(e.currentTarget)}
                style={{ paddingLeft: props.padding, paddingRight: props.padding, height: props.size == "small" ? '25px' : '50px' }}
            >
                {props.image && <img src={props.image} alt="button prefix" style={{ marginRight: '0.5rem' }} />}
                {props.text}
            </StyledButton>
        </StyledButtonContainer>
    );
}

export default Button;
